import { render, staticRenderFns } from "./CircleName.vue?vue&type=template&id=3dd43851&scoped=true"
import script from "./CircleName.vue?vue&type=script&lang=js"
export * from "./CircleName.vue?vue&type=script&lang=js"
import style0 from "./CircleName.vue?vue&type=style&index=0&id=3dd43851&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd43851",
  null
  
)

export default component.exports